import { Box, VStack, Icon, Heading, Text, Button, useColorModeValue } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { MdStorefront } from "react-icons/md";

const NoStoresState = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.800", "white");
  const subtleTextColor = useColorModeValue("gray.600", "gray.300");
  const iconBg = useColorModeValue("blue.50", "gray.700");

  return (
    <Box
      bg={bgColor}
      border="1px solid"
      borderColor={borderColor}
      borderRadius="xl"
      p={12}
      textAlign="center"
    >
      <VStack spacing={4}>
        <Box p={4} borderRadius="full" bg={iconBg}>
          <Icon as={MdStorefront} boxSize={10} color="blue.500" />
        </Box>
        <Heading size="md" color={textColor}>
          No stores have been created yet
        </Heading>
        <Text color={subtleTextColor} maxW="md">
          Please create a store before managing your menus. Categories, items, customizations,
          and schedules are all tied to a specific store.
        </Text>
        <Button colorScheme="blue" mt={2} onClick={() => navigate("/stores")}>
          Create Store
        </Button>
      </VStack>
    </Box>
  );
};

export default NoStoresState;
